import { Injectable } from '@angular/core';
import { HttpClient,  HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { mergeMap, catchError, map } from 'rxjs/operators';

import { IDataGridPageRequest } from '../modelos/data-grid.interface';
import { IAdministrarNotificacionFiltroBuscarRequest, IGenerarAgrupacionRequest, IEditarAgrupacionRequest, IDeleteAgrupacionRequest, IActualizarMarcarNotificacionRequest } from '../modelos/filtro-api.interface';
import { convertObjectToGetParams } from '../functions/http.helpers';
import { ToastService } from '../shared/services/toast.service';
import { environment } from 'src/environments/environment';

const KEYSTORAGE_SESSION = "PROVIAS_SESION_ACTUAL";

@Injectable({
  providedIn: 'root'
})
export class UsuariosService {

   private urlCasilla: string = environment.gatewayUrl + `/c/v1/CasillaElectronica/`;
   private urlNotificacion: string = environment.gatewayUrl + `/c/v1/Notificacion/`;  
   private urlUbigeo: string = environment.gatewayUrl + `/t/v1/Ubigeo/`;
   private urlApiGateway: string = environment.gatewayUrl + `/api/v1`;
   private urlApiSeguridad: string = environment.gatewayUrl+ `/sso/v1`;
  
  constructor(
    private http: HttpClient,
    private toast: ToastService 
  ) { }

  registroUsuarioServicio = (
    registroUsuario
  ): Observable<any> => {
    return this.http.post(`${this.urlApiSeguridad}/Usuarios/Insertar-UsuarioPortal`, registroUsuario)
    .pipe(
      map(response => {
        return response;
      }),
      catchError(this.handleErrorResponse)
    );
  };

  enviarEmailDatosUsuario = (dato1: string, dato2: string, dato3: string, dato4): Observable<any> => {
    
    return this.http.post(`${this.urlApiGateway}/CasillaElectronica/enviar-email`, {}, {
        params: {
          correo: dato1, sujeto: dato2, texto: dato3, usarHtml: dato4
        }
      });
  };
  
  servicioRenat = (ruc: string): Observable<any> => {
    
    return this.http.post(`${this.urlApiGateway}/Seguridad/buscar-por-ruc`, {}, {
        params: {
          request: ruc
        }
      }).pipe(
        map(response => {
          return response;
        }),
        catchError(this.handleErrorResponse)
      );;
  };

  servicioSunat = (ruc: string): Observable<any> => {
    
    return this.http.post(`${this.urlApiGateway}/Seguridad/buscar-ruc-sunat`, {}, {
        params: {
          request: ruc
        }
      }).pipe(
        map(response => {
          return response;
        }),
        catchError(this.handleErrorResponse)
      );;
  };

  servicioDniPide = (request): Observable<any> => {
    //return this.http.post(`${this.urlApiSeguridad}/Usuarios/Insertar-UsuarioPortal`, registroUsuario)
    return this.http.post(`${this.urlApiGateway}/Seguridad/buscar-dni`, request).pipe(
        map(response => {
          return response;
        }),
        catchError(this.handleErrorResponse)
      );;
  };

  validarUsuario = (
    pnTipo: number,
    pnTipoDocumento: number,
    pnPais: number,
    pcNroDocumento: string
  ): Observable<any> => 
  {
    const params = convertObjectToGetParams({ pnTipo, pnTipoDocumento, pnPais, pcNroDocumento });
    console.log('validar USUARIO', params);
    debugger;
    return this.http.get(`${this.urlApiSeguridad}/Usuarios/ValidarUsuario`, { params })
    .pipe(
      map(response => {
        return response;
      }),
      catchError(this.handleErrorResponse)
    );
  };

  validarAcceso = (dato): Observable<any> => {
  
    /*return this.http.post(`${this.urlApiSeguridad}/Usuarios/ValidarAcceso`, {}, {
      params: {
        pnTipo: dato1, pnTipoDocumento: dato2, pnPais: dato3, pcNroDocumento: dato4, pcClave: dato5
      }
      });*/
    return this.http.post(`${this.urlApiSeguridad}/Usuarios/ValidarAcceso`, dato).pipe(
      map(response => {
        return response;
      }),
      catchError(this.handleErrorResponse)
    );;    
  };

  /*validarAccesoSiFirma = (dato1: string, dato2: string): Observable<any> => {
    
    return this.http.post(`${this.urlApiSeguridad}/Usuarios/ValidarAccesoSiFirma`, {}, {
        params: {
          pcUsuario: dato1, pcClave: dato2
        }
      });
  };*/
  
  validarAccesoSiFirma = (dato): Observable<any> => {
    
    /*return this.http.post(`${this.urlApiSeguridad}/Usuarios/ValidarAccesoSiFirma`, dato
      });*/
    return this.http.post(`${this.urlApiSeguridad}/Usuarios/ValidarAccesoSiFirma`, dato).pipe(
        map(response => {
          return response;
        }),
        catchError(this.handleErrorResponse)
      );;
  };

  validarAccesoSigo = (dato): Observable<any> => {
    
    return this.http.post(`${this.urlApiSeguridad}/Usuarios/ValidarAccesoSigo`, dato).pipe(
        map(response => {
          return response;
        }),
        catchError(this.handleErrorResponse)
      );;
  }; 
  
  validarRecuperar = (
    pnTipo: number,
    pnTipoDocumento: number,
    pnPais: number,
    pcNroDocumento: string,
    pcCodigo: string
  ): Observable<any> => 
  {
    const params = convertObjectToGetParams({ pnTipo, pnTipoDocumento, pnPais, pcNroDocumento, pcCodigo });
    return this.http.get(`${this.urlApiSeguridad}/Usuarios/ValidarRecuperar`, { params })
    .pipe(
      map(response => {
        return response;
      }),
      catchError(this.handleErrorResponse)
    );
  };

  cambioClave = (
    pnPk: number,
    pnTipo: number,
    pcClave: string,
    pcClaveNew: string
  ): Observable<any> => 
  {
    const params = convertObjectToGetParams({ pnPk, pnTipo, pcClave, pcClaveNew });
    return this.http.get(`${this.urlApiSeguridad}/Usuarios/PortalCambioClave`, { params })
    .pipe(
      map(response => {
        return response;
      }),
      catchError(this.handleErrorResponse)
    );
  };

  listarPais = (pnTipo: number): Observable<any> => 
  {
    const params = convertObjectToGetParams({ pnTipo});
    return this.http.get(`${this.urlApiSeguridad}/Usuarios/Listar-Pais`, { params });
  };

  listarTipoDocumentoPais = (pkPais: number, pnTipo: number): Observable<any> => 
  {
    const params = convertObjectToGetParams({ pkPais, pnTipo});
    return this.http.get(`${this.urlApiSeguridad}/Usuarios/Listar-TipoDocumento-Pais`, { params });
  };

  validarRuc1 = (
    uRuc: string
  ): Observable<any> => 
  {
    const url = "https://api.sunat.cloud/ruc/"+uRuc; // site that doesn’t send Access-Control-*
    fetch(url)
    .then(response => response.text())
    .then(contents => console.log(contents))
    .catch(() => console.log("Can’t access " + url + " response. Blocked by browser?"))
    
    return this.http.get(`https://api.sunat.cloud/ruc/`+uRuc, {  });
  }
  validarRuc = (
    uRuc: string
  ): Observable<any> => 
  {
    const params = convertObjectToGetParams({ uRuc });
    return this.http.get(`${this.urlApiGateway}/Bonficacion/buscar-razon-social`, {     
    })
    .pipe(
      map(response => {
        return response;
      }),
      catchError(this.handleErrorResponse)
    )
  }
  
  descargarArchivoNotificacion = (
    rutaArchivo: string,
    nombreArchivoSinExtension: string
  ) => 
  {
    const params = convertObjectToGetParams({ rutaArchivo, nombreArchivoSinExtension  });
    //headers:headers
    this.http.get(`${this.urlApiGateway}descargar-archivo-notificacion`,{
      params,
      responseType: 'arraybuffer'
    } 
     )
     .pipe(
      map(response => {
        return response;
      }),
      catchError(this.handleErrorResponse)
    )
     .subscribe(
      (response) => {
        //console.log('Archivo', response);
      this.downLoadFile(response, "application/octet-stream", nombreArchivoSinExtension + '.pdf')
      },
      (error) => {
        alert('No se encontró el archivo.')
      });
  }

  emailRegistro = (
    registroMovimiento
  ): Observable<any> => {
    return this.http.post(`${this.urlApiGateway}/Seguridad/enviar-email-registro`, registroMovimiento)
    .pipe(
      map(response => {
        return response;
      }),
      //catchError(this.handleErrorResponse)
    );
  };

  emailCodigo = (
    registroMovimiento
  ): Observable<any> => {
    return this.http.post(`${this.urlApiGateway}/Seguridad/enviar-codigo-verifica`, registroMovimiento)
    .pipe(
      map(response => {
        return response;
      }),
      //catchError(this.handleErrorResponse)
    );
  };
  
  private downLoadFile(data: any, type: string, fileName: string) {
    let blob = new Blob([data], { type: type});
    let url = window.URL.createObjectURL(blob);
    
    var downloadLink = document.createElement("a");
    downloadLink.href = url;
    downloadLink.download = fileName;

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  } 

  private obtenerAuthHeaders = () => {
    let headers = new HttpHeaders();
    headers.append('Authorization', 'Bearer ' + localStorage.getItem(KEYSTORAGE_SESSION));

    return headers;
  }

  private handleErrorResponse = (error: HttpErrorResponse) => {
    if (error.status == 401)
    {
      this.toast.error("Su sesión ha expirado. Por favor recargue la página para continuar.");
    }

    return Observable.throw(error);
  }

}
